import React, { useState, useEffect, useRef } from "react";
import "./LicensesTable.scss";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { sidebarReducer, CompanyReducer } from "../../Redux/store";
import moment from 'moment';
import filter from '../../images/filter.svg';
import Uparrow from '../../images/arrow-up.svg';
import Downarrow from '../../images/arrow-down1.svg'
import { Link, Route, Navigate, useNavigate } from 'react-router-dom';
import { Button, Menu, MenuItem } from "@mui/material";
import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
  DeleteFailureAlert
} from "../../components/Alert_msg/alert_msg";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';



function ListCompany() {

  const [companyData, setCompanyData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [companyFilterOpen, setCompanyFilterOpen] = useState(false);
  const [customerFilterOpen, setCustomerFilterOpen] = useState(false);
  const [statusFilterOpen, setStatusFilterOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [filteredCompanyData, setFilteredCompanyData] = useState([]);
  const [filteredCustomerData, setFilteredCustomerData] = useState([]);
  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [softwareFilterOpen, setSoftwareFilterOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");

  // Dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //Add user and Edit user related selectors
  const datarefresh = useSelector((state) => state.company.refresh);


  const apiLoad = useSelector((state) => state.sidebar.apiLoad);




  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          '/v1/licensedetails/list', {
          headers: {
            'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
          }
        }
        );
        // console.log("response", response)
        const data = response.data.data.rows;

        if (data.length > 0) {
          setCompanyData(response.data.data.rows);
          setFilteredCompanyData(response.data.data.rows);
          setFilteredCustomerData(response.data.data.rows);
          setLoading(false);
          dispatch(sidebarReducer.apiLoad(false));
          setLicenseDetails(response.data.data.rows);

        } else {
          console.error("Invalid server response format:", data);
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const date = moment.utc(dateString).format('DD-MMM-YYYY');

    if (date === "Invalid date") {
      return "";
    }

    return date;
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortedColumn(column);
      setSortDirection('asc');
    }
  };


  const handleCompanyFilter = (companyName) => {
    setSelectedCompany(companyName);
    setCompanyFilterOpen(false);
    if (companyName === "All") {
      setFilteredCompanyData(companyData);
    } else {
      const filteredData = companyData.filter(company => company.master_company.te_companyname === companyName);
      setFilteredCompanyData(filteredData);
    }
  };

  const handleCustomerFilter = (customerName) => {
    setSelectedCustomer(customerName);
    setCustomerFilterOpen(false);
    if (customerName === "All") {
      setFilteredCompanyData(companyData);
    } else {
      const filteredData = companyData.filter(company => company.master_company.te_customername === customerName);
      setFilteredCompanyData(filteredData);
    }
  };

  const getArrowIcon = (column) => {
    if (sortedColumn === column) {
      return sortDirection === 'asc' ? Uparrow : Downarrow;
    }
    return Uparrow;
  };

  const handleStatusFilter = (status) => {
    setSelectedStatus(status);
    setStatusFilterOpen(false)
    if (status === "All") {
      setFilteredCompanyData(companyData);
    } else {
      const filteredData = companyData.filter((company) => company.te_islicenseactivated === (status === "Active"));
      setFilteredCompanyData(filteredData);
    }
  };

  const handleSoftwareFilter = (softwareName) => {
    setSelectedSoftware(softwareName);
    setSoftwareFilterOpen(false);
    if (softwareName === "All") {
      setFilteredCompanyData(companyData);
    } else {
      const filteredData = companyData.filter(company => company.master_pack.te_bundlename === softwareName);
      setFilteredCompanyData(filteredData);
    }
  };

  const getUniqueCompanies = () => {
    const uniqueCompanies = ['All', ...new Set(companyData.map(company => company.master_company.te_companyname))];
    return uniqueCompanies;
  };

  const getUniqueCustomers = () => {
    const uniqueCustomers = ['All', ...new Set(companyData.map(customer => customer.master_company.te_customername))];
    return uniqueCustomers;
  };

  const getUniqueSoftware = () => {
    const uniqueSoftware = ['All', ...new Set(companyData.map(company => company.master_pack.te_bundlename))];
    return uniqueSoftware;
  };
  const getUniqueStatuses = () => {
    const uniqueStatuses = ['All', 'Active', 'Inactive'];
    return uniqueStatuses;
  };


  const handleRowClick = (te_lmsid) => {
    navigate('/LiceseDetails/' + te_lmsid);

  };

  const sortedData = (data) => {
    if (sortedColumn) {
      return data.sort((a, b) => {
        const valueA = a[sortedColumn];
        const valueB = b[sortedColumn];
        if (valueA < valueB) {
          return sortDirection === 'asc' ? -1 : 1;
        }
        if (valueA > valueB) {
          return sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return data;
  };
  return (
    <div className="LicenseTable">
      <div
        style={{
          minHeight: "63vh",
          overflowY: "auto"
        }}
      >
        {apiLoad ? (
          <div
            style={{
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
          </div>
        ) : (
          <div>

            <div className="License-details">

              <div >
                <div className="d-flex " style={{ marginBottom: "30px" }}>
                  <h5 style={{ marginRight: "auto", fontSize: "35px" }}>License Details</h5>
                  <button className="download-button" style={{ marginRight: "10px" }}>Download Report</button>
                </div>
                <div className="License-table">
                  <div className="heading">License Details</div>
                  <div style={{ height: "calc(58vh - 50px)" }}>
                    {companyData.length === 0 ? (
                      <div className="col text-center">
                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", margin: "100px" }}>
                          <CircularProgress color="inherit" />
                        </Box>
                      </div>
                    ) : (
                      <table className="table-data">
                        <thead className="License-table-head" style={{ position: "sticky" }}>
                          <tr>

                            <th id="company-filter-icon">
                              <div onClick={() => handleSort('master_company.te_companyname')}>
                                Company
                                <img

                                  className="filter-icon"
                                  src={filter}
                                  onClick={() => setCompanyFilterOpen(!companyFilterOpen)}
                                />
                              </div>
                              <Menu

                                anchorEl={document.getElementById('company-filter-icon')}
                                open={companyFilterOpen}
                                onClose={() => setCompanyFilterOpen(false)}
                              >
                                {getUniqueCompanies().map((company, index) => (
                                  <MenuItem key={index} onClick={() => handleCompanyFilter(company)}>{company}</MenuItem>
                                ))}
                              </Menu>

                            </th>
                            <th id="customer-filter-icon">
                              <div 
                              // onClick={() => handleSort('te_iscreatedby')}
                              >
                                Customer
                                <img
                                  className="filter-icon"
                                  src={filter}
                                  onClick={() => setCustomerFilterOpen(!customerFilterOpen)}
                                />
                              </div>

                              <Menu
                                anchorEl={document.getElementById('customer-filter-icon')}
                                open={customerFilterOpen}
                                onClose={() => setCustomerFilterOpen(false)}
                              >
                                {getUniqueCustomers().map((customer, index) => (
                                  <MenuItem key={index} onClick={() => handleCustomerFilter(customer)}>{customer}</MenuItem>
                                ))}
                              </Menu>

                            </th>
                            <th id="software-filter-icon">
                              Software
                              <img
                                className="filter-icon"
                                src={filter}
                                onClick={() => setSoftwareFilterOpen(!softwareFilterOpen)}
                              />
                              <Menu
                                anchorEl={document.getElementById('software-filter-icon')}
                                open={softwareFilterOpen}
                                onClose={() => setSoftwareFilterOpen(false)}
                               >
                                {getUniqueSoftware().map((software, index) => (
                                  <MenuItem key={index} onClick={() => handleSoftwareFilter(software)}>{software}</MenuItem>
                                ))}
                              </Menu>
                            </th>
                            {/* <th>Software<img className="filter-icon" src={filter} /></th> */}
                            <th>
                              Issue Date
                              <img  onClick={() => handleSort('te_licenseactivationdate')} className="Uparrow-icon" src={getArrowIcon('te_licenseactivationdate')} />
                            </th>
                            <th >
                              Expiry Date
                              <img onClick={() => handleSort('te_licenseexpirationdate')} className="Uparrow-icon" src={getArrowIcon('te_licenseexpirationdate')} />
                            </th>
                            <th id="status-filter-icon">
                              Status
                              <img className="filter-icon" src={filter} onClick={() => setStatusFilterOpen(!statusFilterOpen)} />
                              <Menu
                                anchorEl={document.getElementById('status-filter-icon')}
                                open={statusFilterOpen}
                                onClose={() => setStatusFilterOpen(false)}
                              >
                                {getUniqueStatuses().map((status, index) => (
                                  <MenuItem key={index} onClick={() => handleStatusFilter(status)}>{status}</MenuItem>
                                ))}
                              </Menu>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="License-table-body">
                          {sortedData(filteredCompanyData).map((company, index) => (
                            <tr key={index}>
                              <td style={{ textDecoration: "underline", cursor: "pointer" }}
                                onClick={() => handleRowClick(company.te_lmsid)}>{company.master_company.te_companyname}</td>
                              <td>{company.master_company.te_customername}</td>
                              <td>{company.master_pack.te_bundlename}</td>
                              <td>{formatDate(company.te_licenseactivationdate)}</td>
                              <td>{formatDate(company.te_licenseexpirationdate)}</td>
                              <td>{company.te_islicenseactivated ? 'Active' : 'Inactive'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>


        )}

      </div>

      <SuccessAlert />
      <FailureAlert />
      <InformationAlert />
      <SuccessUpdate />
      <FailureUpdate />
      <SuccessDelete />
      <DeleteFailureAlert />
    </div>
  );
}

export default ListCompany;
